import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { HomepageComponent } from './homepage/homepage.component';
import { LoginComponent } from './login/login.component';

export const routes: Routes = [
  {
    path: '',
    component: HomepageComponent
  },
  {
    path: 'pages',
    canLoad: [AutoLoginPartialRoutesGuard],
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
  },
  {
    path: 'unauthorized',
    component: LoginComponent
  },
  {
    path: '*',
    redirectTo: ''
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {anchorScrolling: 'enabled'})
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
